import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * ShareFile Migration management moved into the Google Drive integration page
 * as a tab (see `_app/backoffice/integrations/google-drive/index.tsx`). This route is
 * kept as a redirect so old links/bookmarks still land in the right place.
 */
export const Route = createFileRoute('/_app/sharefile-migration/')({
  beforeLoad: () => {
    throw redirect({
      to: '/backoffice/integrations/google-drive',
      search: { tab: 'sharefile-migration' },
    })
  },
})
